import { useEffect } from "react";
import useOwner from "../modules/users/hooks/useOwner";
import _ from "underts";
import { trpc } from "../modules/main/components/trpc.ts";
import { SeletectedDoctorState } from "../modules/main/state/globalState";
import { useAtom } from "jotai";
import styles from "./DoctorChoose.module.css";
import useUser from "../modules/users/hooks/useUser";
import { skipToken } from "@tanstack/react-query";

const DoctorChooser = () => {
  const [selectedDoctor, onSelectDoctor] = useAtom(SeletectedDoctorState);
  const user = useUser();
  const doctors =
    trpc.user.getDoctorsForSecretary.useQuery(user ? undefined : skipToken)
      .data || [];

  useEffect(() => {
    if (!selectedDoctor && doctors.length > 0) {
      onSelectDoctor(_.first(doctors)?.id || null);
    }
  }, [JSON.stringify(doctors)]);
  return (
    <div className={styles.spacer}>
      <select
        value={selectedDoctor || ""}
        id="doctor_chooser"
        onChange={(e) => onSelectDoctor(e.currentTarget.value)}
      >
        {[
          <option key="initialValueDoctorChooserSelectKey" value="">
            Choisir Docteur
          </option>,
        ].concat(
          doctors.map((doctor) => (
            <option key={doctor.id} value={doctor.id}>
              {doctor.fullname}
            </option>
          ))
        )}
      </select>
    </div>
  );
};

export default DoctorChooser;
